import React, { useState, useEffect } from 'react';
import { twoFAAPI } from '../services/api';
const logo = process.env.PUBLIC_URL + '/pelicanplanner-logo.png';
const bgImage = process.env.PUBLIC_URL + '/japanesefishingvillaige.png';

function ForcedTwoFASetup({ onComplete, onLogout }) {
  const [step, setStep] = useState('loading'); // loading | qr | verify
  const [qrCode, setQrCode] = useState('');
  const [secret, setSecret] = useState('');
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    twoFAAPI.setup()
      .then(res => {
        setQrCode(res.data.qrCode);
        setSecret(res.data.secret);
        setStep('qr');
      })
      .catch(() => setError('Failed to load setup. Please try signing out and back in.'));
  }, []);

  const handleVerify = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await twoFAAPI.verifySetup({ secret, code });
      onComplete();
    } catch (err) {
      setError(err.response?.data?.error || 'Invalid code — please try again.');
    } finally {
      setLoading(false);
    }
  };

  const formatSecret = (s) => s ? s.match(/.{1,4}/g)?.join(' ') : '';

  return (
    <div className="auth-container" style={{ backgroundImage: `url(${bgImage})` }}>
      <div className="auth-card" style={{ maxWidth: '460px' }}>
        <div style={{ textAlign: 'center', marginBottom: '20px' }}>
          <img src={logo} alt="Pelican Planner"
            style={{
              width: '72px', height: '72px', margin: '0 auto 12px',
              borderRadius: '14px', display: 'block', objectFit: 'cover',
              boxShadow: '0 4px 16px rgba(255,107,107,0.3)'
            }} />
          <h1 className="auth-title" style={{ fontSize: '20px' }}>Two-Factor Authentication Required</h1>
          <p className="auth-subtitle" style={{ fontSize: '13px' }}>
            Set up 2FA to secure your account before continuing.
          </p>
        </div>

        {error && (
          <div className="alert alert-error" style={{ marginBottom: '16px', fontSize: '14px' }}>
            {error}
          </div>
        )}

        {step === 'loading' && !error && (
          <div style={{ textAlign: 'center', padding: '24px' }}>
            <div className="spinner"></div>
          </div>
        )}

        {step === 'qr' && (
          <form onSubmit={handleVerify}>
            <p style={{ fontSize: '13px', color: 'var(--text-secondary)', margin: '0 0 14px' }}>
              Scan this QR code with <strong>Google Authenticator</strong> or <strong>Authy</strong>, then enter the 6-digit code below.
            </p>
            <div style={{ textAlign: 'center', marginBottom: '16px' }}>
              <img src={qrCode} alt="2FA QR Code"
                style={{ width: '180px', height: '180px', borderRadius: '8px', border: '4px solid white' }} />
            </div>
            <div style={{ marginBottom: '18px' }}>
              <p style={{ fontSize: '11px', color: 'var(--text-muted)', margin: '0 0 5px' }}>
                Can't scan? Enter this key manually:
              </p>
              <code style={{
                display: 'block', padding: '7px 11px', borderRadius: '6px',
                background: 'var(--bg-secondary)', fontSize: '12px',
                letterSpacing: '2px', wordBreak: 'break-all', color: 'var(--text-primary)'
              }}>
                {formatSecret(secret)}
              </code>
            </div>
            <div className="form-group">
              <label className="form-label">Authentication Code</label>
              <input
                type="text" className="form-input"
                value={code} onChange={e => setCode(e.target.value)}
                placeholder="000 000" maxLength={7} autoComplete="one-time-code"
                autoFocus required
                style={{ textAlign: 'center', fontSize: '22px', letterSpacing: '6px', fontFamily: 'monospace' }}
              />
            </div>
            <button type="submit" className="btn btn-primary btn-block" disabled={loading}
              style={{ padding: '12px', marginTop: '4px' }}>
              {loading ? 'Verifying...' : 'Verify & Continue'}
            </button>
            <button type="button" onClick={onLogout}
              style={{ marginTop: '12px', width: '100%', background: 'none', border: 'none', color: 'var(--text-muted)', fontSize: '13px', cursor: 'pointer' }}>
              Sign out
            </button>
          </form>
        )}
      </div>
    </div>
  );
}

export default ForcedTwoFASetup;
